module.exports = __webpack_public_path__ + "media/images/ig-glyph-fill@2x-153ba761aaaa986edc574f0669b07ba2.png";